import type { ThemeValue } from "~/components/Theme/useThemePaletteType";
import type { ThemePaletteType } from "~/theme/index";
let currentTheme: ThemeValue | "unknown" = "unknown";
let currentThemePaletteType: ThemePaletteType | "unknown" = "unknown";
let themePaletteTypeChangedSubscriptions: Array<(newThemePaletteType: ThemePaletteType) => void> = [];
export const currentThemeContext = {
    getCurrentTheme() {
        return currentTheme;
    },
    getCurrentThemePaletteType() {
        return currentThemePaletteType;
    },
    setCurrentTheme(theme: ThemeValue) {
        currentTheme = theme;
    },
    setCurrentThemePaletteType(themePaletteType: ThemePaletteType) {
        currentThemePaletteType = themePaletteType;
        themePaletteTypeChangedSubscriptions.forEach((subscription) => {
            subscription(themePaletteType);
        });
    },
    subscribeToThemePaletteTypeChanges(subscription: (newThemePaletteType: ThemePaletteType) => void): UnsubscribeToThemePaletteTypeChanges {
        themePaletteTypeChangedSubscriptions = [...themePaletteTypeChangedSubscriptions, subscription];
        return () => {
            themePaletteTypeChangedSubscriptions = themePaletteTypeChangedSubscriptions.filter((s) => s !== subscription);
        };
    },
};
export type UnsubscribeToThemePaletteTypeChanges = () => void;
